import { Phone, CheckCircle, Home } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const HomeVisitService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';
  const conditions = ['Post-surgical recovery at home', 'Elderly patients with limited mobility', 'Stroke and neurological recovery', 'Chronic pain management', 'Fracture rehabilitation', 'Arthritis management', 'Paediatric home therapy', 'Bedridden patient care'];
  const equipment = ['Portable TENS/IFT units', 'Exercise bands and tools', 'Manual therapy techniques', 'Home exercise programs', 'Mobility aids training'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Home Visit Physiotherapy</h1>
          <p className="service-subtitle">Expert physiotherapy at your doorstep anywhere in Goa</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Home Visit Physiotherapy?</h2>
            <p>Home visit physiotherapy brings professional, clinical-quality treatment to the comfort of your home. Our certified physiotherapists come equipped with portable equipment to deliver the same high standard of care you'd receive at our clinic.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}><CheckCircle size={20} /><span>{condition}</span></li>
              ))}
            </ul>

            <h2>What to Expect During Home Visits</h2>
            <p>Your physiotherapist arrives at your preferred time with all necessary portable equipment. After assessing your condition and home environment, they provide hands-on treatment, therapeutic exercises, and equipment-based therapy as needed. You'll also receive a customized home exercise program.</p>

            <h2>Equipment We Bring</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (<span key={index} className="equipment-tag">{item}</span>))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Home size={20} />Request Home Visit on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>Which areas in Goa do you cover?</AccordionTrigger>
                <AccordionContent>We provide home visits across all major areas in Goa including Panjim, Miramar, Porvorim, Mapusa, Candolim, Calangute, and surrounding regions. Contact us for areas not listed.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Is home visit treatment as effective as clinic treatment?</AccordionTrigger>
                <AccordionContent>Yes, home visit treatment is equally effective. Our physiotherapists bring professional equipment and provide the same quality care. Being in your home environment can even be beneficial for functional training.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>How do I prepare for a home visit?</AccordionTrigger>
                <AccordionContent>Clear a comfortable space for treatment, have any medical reports ready, wear loose comfortable clothing, and ensure someone is home to assist if needed during the session.</AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>Can the same physiotherapist visit each time?</AccordionTrigger>
                <AccordionContent>Yes, we assign the same physiotherapist for continuity of care. This builds rapport and ensures consistent, personalized treatment throughout your recovery.</AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomeVisitService;